import classes from "./ContactItem.module.css";
import React from "react";

const ContactItem = (props) => {
  return (
    <a
      className={classes.ContactLink}
      target="_blank"
      rel="noreferrer"
      href={props.action}
    >
      <div className={classes.ContactItem}>
        <span className={classes.Icon}>
          <i style={props.style} className={props.icon}></i>
        </span>
      </div>
    </a>
  );
};

export default ContactItem;
